import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

export function SoonLabel({ children }: { children: ReactNode }) {
  return (
    <Box component="span" sx={{ color: 'text.disabled' }}>
      {children}{' '}
      <Typography component="span" variant="caption" sx={{ fontStyle: 'italic' }}>
        (soon)
      </Typography>
    </Box>
  );
}
